'use client';

import Image from '@src/components/atoms/safe-image';

import { Header } from "@src/components/century-21-page";

// Assets
import Vector from "@public/png/vector-bg-1.png";

import useWhatsappMessage from '@src/hooks/useWhatsapp';
import useRedirect from '@src/hooks/useRedirect';

const NotFound = () => {
  const redirect = useRedirect()
  const { sendMessage } = useWhatsappMessage();
  const handleSendMessage = (type = "button") => {
    sendMessage({
      phone: "+6285211627223",
      type,
      message: "Halo CENTURY 21 Indonesia"
    })
  }

  return (
    <div className='bg-white-3'>
      <Header />

      <div className="main-wrapper relative h-[calc(100vh-66px-118px)]">
        <div className="content-wrapper relative z-[2] h-full flex flex-col items-center justify-center">
          <p className='text-80 font-sfpro-bold text-center 
            dd-2xl:text-52 
            dd-lg:text-start'>Halaman Tidak Ditemukan,</p>
          <p className='text-80 font-sfpro-bold text-center mb-6 
            dd-2xl:text-52 
            dd-lg:text-start'>Tapi Pilihan Properti Masih Banyak</p>
          <p className='text-17 text-center 
            dd-lg:text-start'>Jangan khawatir, kami punya banyak pilihan properti menarik yang siap untuk Anda jelajahi.</p>
        </div>
        <Image
          src={Vector}
          alt='Vectors'
          width="auto"
          height="auto"
          className='absolute z-[1] w-full h-full bottom-0 right-0 object-cover'
        />
      </div>
      <p className='text-center text-17 text-grey-1 py-[48px]'>Silahkan kembali ke <span onClick={() => { redirect("/") }} className='font-sfpro-bold cursor-pointer text-black-1'>BERANDA</span> atau <span onClick={handleSendMessage} className='font-sfpro-bold cursor-pointer text-black-1'>HUBUNGI</span> untuk informasi lebih lanjut.</p>
    </div>
  )
}

export default NotFound